import { PERMISSIONS } from '@helios/authz';
import { useScopedOperationalMutation, useScopedOperationalQuery } from '@/hooks/useScopedOperationalQuery';
import { infraApi } from './infra.api';

export function useInfraCommandCenter() {
  return useScopedOperationalQuery('infra', PERMISSIONS.PLATFORM_ADMIN, infraApi.getDashboard, 60_000);
}
export function useRunInfraReadiness() {
  return useScopedOperationalMutation('infra', PERMISSIONS.PLATFORM_ADMIN, (_input: void, options) => infraApi.runReadiness(undefined, options));
}
